module.exports = __webpack_public_path__ + "img/prevert.7686240d.jpg";